import React, { Component } from "react";

import { connect } from "react-redux";
import ChoiceList from "../Choices/ChoiceList";
import ProductOptionGroup from "../Groups/";
class OptionGroupList extends Component {
  state = { level: this.props.level || "" };

  render() {
    const {
      option,
      selectedOptions,
      controlOptions,
      themeColor,
      discountAmount,
      productQuantity,
      productUsedComponents,
      editedProduct,
      groupID,
      optionKey,
    } = this.props;
    const choices = option.choices.map((choice) => {
      const isChoiceSelected = this.props.checkChoiceSelected(
        choice.id,
        choice.option,
        groupID ?? groupID
      );
      const conditionalOptions = this.props.getConditionalOptions(
        choice.id,
        choice.option
      );
      const isParent = isChoiceSelected && conditionalOptions?.length > 0;

      return (
        <div
          key={`${optionKey} ${choice.id}`}
          className="choice-container"
          style={{
            position: "relative",
            border:
              option.layout !== "dense" &&
              `2px solid ${isChoiceSelected ? themeColor : "transparent"}`,
            borderRadius: option.layout !== "dense" ? "6px" : "0",
            marginBottom:
              option.layout !== "dense"
                ? "16px"
                : isParent && isChoiceSelected && "8px",

            paddingBottom:
              option.layout !== "dense" &&
              isParent &&
              isChoiceSelected &&
              "8px",
            transition:
              "border 0.3s ease-in-out, border-radius 0.3s ease-in-out, margin-bottom 0s ease-in-out 0.1s",
          }}
        >
          <ChoiceList
            key={`${optionKey} ${choice.id}`}
            choice={{ ...choice }}
            option={option}
            selectedOptions={selectedOptions}
            controlOptions={controlOptions}
            themeColor={themeColor}
            discountAmount={discountAmount}
            productQuantity={productQuantity}
            isParent={isChoiceSelected && conditionalOptions?.length > 0}
            productUsedComponents={productUsedComponents}
            editedProduct={editedProduct}
            groupID={groupID}
            level={this.state.level}
            optionKey={optionKey}
          />

          <div
            className={`conditional-option-child ${
              isChoiceSelected ? "open" : ""
            }`}
          >
            {conditionalOptions?.map((op) => (
              <div key={op.id}>
                <ProductOptionGroup
                  key={op.id}
                  option={op}
                  controlOptions={controlOptions}
                  selectedOptions={selectedOptions}
                  themeColor={themeColor}
                  discountAmount={discountAmount}
                  parentStyle={this.props.parentStyle || ""}
                  productQuantity={productQuantity}
                  productUsedComponents={productUsedComponents}
                  editedProduct={editedProduct}
                  editMode={this.props.editMode}
                  inInGroup={groupID ? true : false}
                  level={"bottom"}
                  sortOrder={op.sort_order}
                  groupID={groupID}
                />
              </div>
            ))}
          </div>
        </div>
      );
    });

    return (
      <div className=" mx-1 p-3" justify="space-around">
        {choices}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(OptionGroupList);
